import { createGlobalStyle } from 'styled-components';
export default createGlobalStyle`
  body {
    background-color: ${p => p.theme.colors.gray100};
    display: flex;
    flex-direction: column;
    font-family: ${p => p.theme.fontFamily.default};
    font-size: ${p => p.theme.fontSize.base};
    min-height: 100vh;
    margin: 0;
    position: relative;
  }
  body:not(.user-is-tabbing) button:focus,
  body:not(.user-is-tabbing) input:focus,
  body:not(.user-is-tabbing) select:focus,
  body:not(.user-is-tabbing) textarea:focus {
    outline: none;
  }
  *, ::after, ::before {
    box-sizing: border-box;
  }
  a{
    color: ${p => p.theme.colors.green400};
    text-decoration: none;
    &:hover{
      text-decoration: none;
    }
    &:visited{
      text-decoration: none;
    }
  }
`;
